require('./bootstrap');
import Vue from 'vue';

import VueGoogleMap from 'vuejs-google-maps'
import 'vuejs-google-maps/dist/vuejs-google-maps.css'
Vue.use(VueGoogleMap, {
    load: {
        apiKey: 'AIzaSyAJlmXmjsZGNK4CxbL4sJcZLOYlOcDmNI0',
        libraries: [/* rest of libraries */]
    }
})

import map from './views/properties/detail_map';

window.vue_properties = new Vue({
    components: {
        'map-view': map
    }
}).$mount('#propery-map-vue-app');
